import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/i-money1.jpg'


const _hoisted_1 = {
  class: "logo position-absolute start-0 end-0 top-0",
  style: {"background-color":"#861727"}
}
const _hoisted_2 = { class: "sidebar-menu" }
const _hoisted_3 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_4 = { class: "sidebar-nav-item" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 1,
  class: "sidebar-nav-item"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = {
  key: 0,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_11 = {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseOne",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseOne"
}
const _hoisted_12 = { class: "title" }
const _hoisted_13 = {
  id: "sidebarCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_14 = { class: "accordion-body" }
const _hoisted_15 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_16 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_17 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_18 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_19 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_20 = {
  key: 4,
  class: "sidebar-sub-menu-item"
}
const _hoisted_21 = {
  key: 5,
  class: "sidebar-sub-menu-item"
}
const _hoisted_22 = {
  key: 1,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_23 = {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwo",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwo"
}
const _hoisted_24 = { class: "title" }
const _hoisted_25 = {
  id: "sidebarCollapseTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_28 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_29 = {
  key: 2,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_30 = {
  id: "sidebarCollapseTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_31 = { class: "accordion-body" }
const _hoisted_32 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_33 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_34 = { class: "title" }
const _hoisted_35 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_36 = {
  key: 3,
  class: "sidebar-nav-item"
}
const _hoisted_37 = { class: "title" }
const _hoisted_38 = {
  key: 4,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_39 = {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseThree",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseThree"
}
const _hoisted_40 = { class: "title" }
const _hoisted_41 = {
  id: "sidebarCollapseThree",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_42 = { class: "accordion-body" }
const _hoisted_43 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_44 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_45 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_46 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_47 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_48 = {
  key: 4,
  class: "sidebar-sub-menu-item"
}
const _hoisted_49 = {
  key: 5,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_50 = {
  id: "sidebarCollapseLedger",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_51 = { class: "accordion-body" }
const _hoisted_52 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_53 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_54 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_55 = {
  key: 6,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_56 = {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseFour",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseFour"
}
const _hoisted_57 = { class: "title" }
const _hoisted_58 = {
  id: "sidebarCollapseFour",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_59 = { class: "accordion-body" }
const _hoisted_60 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_61 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_62 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_63 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_64 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_65 = {
  key: 4,
  class: "sidebar-sub-menu-item"
}
const _hoisted_66 = {
  key: 5,
  class: "sidebar-sub-menu-item"
}
const _hoisted_67 = {
  key: 6,
  class: "sidebar-sub-menu-item"
}
const _hoisted_68 = {
  key: 7,
  class: "sidebar-sub-menu-item"
}
const _hoisted_69 = {
  key: 8,
  class: "sidebar-sub-menu-item"
}
const _hoisted_70 = { class: "sidebar-nav-item" }
const _hoisted_71 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.stateStoreInstance.show==true)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
        id: "sidebar-area",
        style: {"background-color":"#861727"}
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: "d-flex align-items-center text-white text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "logo-icon",
                style: {"max-width":"25%"}
              }, null, -1),
              _createElementVNode("span", { class: "fw-bold ms-10" }, "IZYPAY", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "border-bottom" }, null, -1)),
          _createElementVNode("button", {
            class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "flaticon-more-1" }, null, -1)),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('sidebar.dashboard')), 1)
                ]),
                _: 1
              })
            ]),
            (_ctx.environment=='DEMO')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.current_permissions('get_transactions'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                        _createVNode(_component_router_link, {
                          to: "/transactions",
                          class: "sidebar-nav-link d-block"
                        }, {
                          default: _withCtx(() => [
                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "flaticon-trolley-cart" }, null, -1)),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('sidebar.collections')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.current_permissions('get_transactions'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createVNode(_component_router_link, {
                          to: "/transferts",
                          class: "sidebar-nav-link d-block"
                        }, {
                          default: _withCtx(() => [
                            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-money" }, null, -1)),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('sidebar.payments')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.environment=='PROD')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.current_permissions('list_contacts_paginate', 'get_transactions', 'validate_payout_transaction', 'get_bulk_payout_status'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                        _createElementVNode("a", _hoisted_11, [
                          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-trolley-cart" }, null, -1)),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('sidebar.transactions')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("ul", _hoisted_15, [
                              (_ctx.current_permissions('get_transactions'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                    _createVNode(_component_router_link, {
                                      to: "/transactions",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.collectedPayments')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('get_transactions'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                    _createVNode(_component_router_link, {
                                      to: "/transferts",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.transfers')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('validate_payout_transaction'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                    _createVNode(_component_router_link, {
                                      to: "/transferts/default/pending",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.pendingTransfers')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('validate_public_token'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                    _createVNode(_component_router_link, {
                                      to: "/transferts/validation/one",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.linksToValidateLevel1')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('validate_payout_transaction'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                    _createVNode(_component_router_link, {
                                      to: "/transferts/validation/two",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.linksToValidateLevel2')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_contact_books'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                    _createVNode(_component_router_link, {
                                      to: "/contacts",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.contacts')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.current_permissions('list_organizations'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                        _createElementVNode("a", _hoisted_23, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-rocket" }, null, -1)),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('sidebar.crm')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("ul", _hoisted_27, [
                              (_ctx.current_permissions('list_organizations'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                    _createVNode(_component_router_link, {
                                      to: "/crm-customers",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.organizations')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.current_permissions('list_users'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                        _cache[11] || (_cache[11] = _createElementVNode("a", {
                          href: "#",
                          class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": "#sidebarCollapseTwo",
                          "aria-expanded": "false",
                          "aria-controls": "sidebarCollapseTwo"
                        }, [
                          _createElementVNode("i", { class: "flaticon-people" }),
                          _createElementVNode("span", { class: "title" }, "Gestion utilisateurs")
                        ], -1)),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("ul", _hoisted_32, [
                              (_ctx.current_permissions('list_users'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                    _createVNode(_component_router_link, {
                                      to: `/utilisateurs/${_ctx.code}`,
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('sidebar.users')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["to"])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('token_session_list'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                    _createVNode(_component_router_link, {
                                      to: "/token-list",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                        _createTextVNode(" Liste des sessions ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.current_permissions('list_accounts'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          to: `/account/${_ctx.code}`,
                          class: "sidebar-nav-link d-block"
                        }, {
                          default: _withCtx(() => [
                            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-bag" }, null, -1)),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('sidebar.myAccounts')), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.current_permissions('list_repayments','list_topups', 'list_business', 'list_providers','global_report'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                        _createElementVNode("a", _hoisted_39, [
                          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-money" }, null, -1)),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('sidebar.finances')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("ul", _hoisted_43, [
                              (_ctx.current_permissions('list_repayments'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                                    _createVNode(_component_router_link, {
                                      to: "/repayment",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.refunds')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_topups'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                    _createVNode(_component_router_link, {
                                      to: "/reloading",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.reloads')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_business'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                                    _createVNode(_component_router_link, {
                                      to: "/business",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.business')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_providers'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                                    _createVNode(_component_router_link, {
                                      to: "/balance",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.balance')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('global_report'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                                    _createVNode(_component_router_link, {
                                      to: "/export",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.operationsStatement')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.current_permissions('list_extended_merchant_accounts'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                        _cache[16] || (_cache[16] = _createElementVNode("a", {
                          href: "#",
                          class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": "#sidebarCollapseLedger",
                          "aria-expanded": "false",
                          "aria-controls": "sidebarCollapseLedger"
                        }, [
                          _createElementVNode("i", { class: "flaticon-bag" }),
                          _createElementVNode("span", { class: "title" }, "Ledger")
                        ], -1)),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("ul", _hoisted_52, [
                              (_ctx.current_permissions('list_extended_merchant_accounts'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                    _createVNode(_component_router_link, {
                                      to: "/ledger/accounts",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode(" Liste des comptes ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_double_entries'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                                    _createVNode(_component_router_link, {
                                      to: "/ledger/doublewrite",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                        _createTextVNode(" Écriture double entrée ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.current_permissions('list_countries', 'list_typeFees', 'list_fees', 'list_providers','public_list_operators','create_all_config','list_operators' ))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                        _createElementVNode("a", _hoisted_56, [
                          _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-setting" }, null, -1)),
                          _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('sidebar.settings')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("ul", _hoisted_60, [
                              (_ctx.current_permissions('list_countries'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_61, [
                                    _createVNode(_component_router_link, {
                                      to: "/country",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.countries')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_typeFees'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_62, [
                                    _createVNode(_component_router_link, {
                                      to: "/typefree",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.feeTypes')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_fees'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_63, [
                                    _createVNode(_component_router_link, {
                                      to: "/fee",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.fees')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_providers'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_64, [
                                    _createVNode(_component_router_link, {
                                      to: "/providor",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.providers')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_operators'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_65, [
                                    _createVNode(_component_router_link, {
                                      to: "/operator",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.operators')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_permissions'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_66, [
                                    _createVNode(_component_router_link, {
                                      to: "/permissions",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.permissions')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_actions'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                    _createVNode(_component_router_link, {
                                      to: "/actions",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.actions')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_configs'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_68, [
                                    _createVNode(_component_router_link, {
                                      to: "/general-setting",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.accountConfiguration')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.current_permissions('list_configs'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                                    _createVNode(_component_router_link, {
                                      to: "/config",
                                      class: "sidebar-sub-menu-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.settingsConfiguration')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_70, [
              _createVNode(_component_router_link, {
                to: "/",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.logout(_ctx.backApi)), ["prevent"])),
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _cache[18] || (_cache[18] = _createElementVNode("i", { class: "flaticon-logout" }, null, -1)),
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t('sidebar.logout')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}